import { getChainId, Network } from '@spritz-finance/sdk'
import { config } from '../../modules/app/config'

/**
 * Known JSON-RPC endpoints.
 * These are the URLs used by the interface when there is not another available source of chain data.
 */
export const RPC_URLS: Record<number, string[]> = {
    [getChainId(Network.Polygon)]: [
        `https://polygon-mainnet.g.alchemy.com/v2/${config.alchemyPolygonKey}`,
    ],
    [getChainId(Network.Ethereum)]: [
        `https://eth-mainnet.g.alchemy.com/v2/${config.alchemyMainnetKey}`,
    ],
    [getChainId(Network.Binance)]: [
        `https://alien-multi-field.bsc.discover.quiknode.pro/${config.quicknodeBSCKey}`,
    ],
    [getChainId(Network.Optimism)]: [
        `https://opt-mainnet.g.alchemy.com/v2/${config.alchemyOptimismKey}`,
    ],
    [getChainId(Network.Arbitrum)]: [
        `https://arb-mainnet.g.alchemy.com/v2/${config.alchemyArbitrumKey}`,
    ],
    [getChainId(Network.Avalanche)]: [
        `https://frosty-cosmological-gas.avalanche-mainnet.quiknode.pro/${config.quicknodeAvalancheKey}/ext/bc/C/rpc`,
    ],
}

const PUBLIC_RPC_URLS: Record<number, string> = {
    [getChainId(Network.Polygon)]: 'https://polygon-rpc.com',
    [getChainId(Network.Ethereum)]: 'https://mainnet.infura.io/v3/',
    [getChainId(Network.Binance)]: 'https://bsc-dataseed.binance.org/',
    [getChainId(Network.Optimism)]: 'https://mainnet.optimism.io',
    [getChainId(Network.Arbitrum)]: 'https://arb1.arbitrum.io/rpc',
    [getChainId(Network.Avalanche)]: 'https://api.avax.network/ext/bc/C/rpc',
}

export const getRpcUrls = (network: Network) => {
    return RPC_URLS[getChainId(network)]
}

export const getRpcUrl = (network: Network) => {
    return RPC_URLS[getChainId(network)][0]
}

export const getPublicRpcUrl = (network: Network) => {
    return PUBLIC_RPC_URLS[getChainId(network)]
}
